import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import helpersNumbers from "../../../helpers/numbers";
import sizesBanner from "./sizes-banner";
import Pages from "../page/Pages";
import ButtonDisable from "../../partials/other/ButtonDisable";

export default function EditPositions() {
  const history = useHistory();
  const params = useParams();
  const positionID = params.positionID;

  let positions = Pages.map((page) => page.positions);
  positions = positions[0];
  let position = positions.filter((position) => position.ID == positionID);
  position = position[0];

  const [message, setMessage] = useState();
  const [basePrice, setBasePrice] = useState(position.base_price);
  const [count, setCount] = useState(position.count);
  const [price, setPrice] = useState(position.price);
  const [width, setWidth] = useState(position.size.split("-")[0]);
  const [height, setHeight] = useState(position.size.split("-")[1]);
  const [pageID, setPageID] = useState();
  const [active, setActive] = useState(position.active);
  const [page, setPage] = useState({});
  const [scoreAlternative, setScoreAlternative] = useState(
    position.score_alternative
  );
  const [activeAlternative, setActiveAlternative] = useState(
    position.allow_alternative
  );
  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  useEffect(() => {
    changePrice();
  }, [basePrice]);

  useEffect(() => {
    changePrice();
  }, [count]);

  useEffect(() => {
    calculateScoreAlternative();
  }, [activeAlternative]);

  const changePrice = () => {
    if (!(count > 0)) {
      setPrice(0);
      return;
    }
    setPrice(Math.floor(basePrice / count));
  };

  useEffect(() => {
    if (price < 0) {
      return;
    }
    calculateScoreAlternative();
  }, [price]);

  const calculateScoreAlternative = () => {
    const scoreAlternative =
      price > parseInt(process.env.REACT_APP_MAX_SCORE_ALTERNATIVE_POSITION)
        ? parseInt(process.env.REACT_APP_MAX_SCORE_ALTERNATIVE_POSITION)
        : price;

    setScoreAlternative(scoreAlternative);
  };

  // const getPosition = async () => {
  //   helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  //   let position = await sendRequestGetPosition(positionID);
  //   helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

  //   if (!position) {
  //     return;
  //   }

  //   let size = position.size.split("-");
  //   setWidth(size[0]);
  //   setHeight(size[1]);
  //   setCount(position.count);
  //   setBasePrice(position.base_price);
  //   setPrice(position.price);
  //   setActive(position.active);
  //   setPageID(position.page_id);
  //   setActiveAlternative(position.allow_alternative);
  //   setScoreAlternative(position.score_alternative);
  //   await getPage(position.page_id);
  // };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateButtonsSize = () => {
    return sizesBanner.map((sizeBanner) => {
      return (
        <div className="col-6 col-md-2 py-2">
          <div
            onClick={(e) => {
              e.preventDefault();
              setWidth(sizeBanner.width);
              setHeight(sizeBanner.height);
            }}
            className="btn btn-primary letter-spacing-finance-number p-2"
          >
            {helpersNumbers.toPersianNum(sizeBanner.height)}
            {"    "}-{"    "}
            {helpersNumbers.toPersianNum(sizeBanner.width)}
          </div>
        </div>
      );
    });
  };

  const inputPriceChangeHandler = (e) => {
    let number = e.target.value;
    number = helpersNumbers.toEnglishNumber(number.replaceAll(",", ""));
    if (number == "") {
      number = 0;
    }
    setBasePrice(parseInt(number));
  };

  const inputPriceBeforeInputHandler = (e) => {
    const regexLetter = new RegExp("^[0-9\b]+$");
    if (!regexLetter.test(e.data)) {
      e.preventDefault();
      return;
    }
  };

  const scrollForSeeMessage = () => {
    const element = document.querySelector(".card-body");
    element.scrollIntoView();
  };

  const getDataForm = () => {
    return {
      count: count + "",
      base_price: basePrice + "",
      price: price + "",
      height: height + "",
      width: width + "",
      active: +active,
      allow_alternative: activeAlternative,
    };
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="ویرایش جایگاه" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link
                  className="btn btn-primary"
                  to={`/positions/${positionID}/view`}
                >
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              <div className="alert alert-warning">
                <p className="text-justify">
                  <i className="fa fa-info pl-2"></i>توجه داشته باشید :{" "}
                </p>
                <ul className="pr-3">
                  <li>
                    <p className="text-justify">
                      تبلیغ بنری جایگزین تبلیغی است که درصورت نبود تبلیغ در
                      جایگاه , نمایش داده میشود و به کاربر نمایش دهنده امتیاز
                      تعلق میگرد
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      امتیاز تبلیغ بنری جایگزین برابر است با مبلغ تبلیغ یک بنر
                      در یک شبانه در صورتیکه مبلغ تبلیغ یک بنر در یک شبانه روز
                      کمتر از ۵۰۰۰ هزار باشد
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      حداکثر امتیاز تبلیغ بنری جایگزین برابر با ۵۰۰۰ است
                    </p>
                  </li>
                </ul>
              </div>

              {messageTag}
              <form>
                <div className="form-group">
                  <label>تعداد بنر در جایگاه</label>
                  <input
                    tabIndex="1"
                    dir="ltr"
                    type="number"
                    id="count"
                    value={count}
                    onChange={(e) => {
                      e.preventDefault();
                      setCount(parseInt(e.target.value));
                    }}
                    className="form-control"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>مبلغ پایه </label>
                  <input
                    tabIndex="2"
                    type="text"
                    id="price"
                    className="form-control number-finance"
                    value={helpersNumbers.toPersianNum(
                      helpersNumbers.toFormatFinanceNumber(basePrice)
                    )}
                    onChange={inputPriceChangeHandler}
                    onBeforeInput={inputPriceBeforeInputHandler}
                    dir="ltr"
                    required
                  />
                </div>

                <div className="form-group">
                  <label>مبلغ نمایش یک تبلیغ در یک شبانه روز :‌ </label>
                  <span
                    className="letter-spacing-finance-number"
                    style={{ fontSize: "22px" }}
                  >
                    {helpersNumbers.toPersianNum(
                      helpersNumbers.toFormatFinanceNumber(price)
                    )}
                  </span>
                </div>

                <div className="form-group">
                  <label className="pl-2">فعال بودن تبلیغ جایگزین بنری</label>
                  <span>
                    <label className="adl-switch">
                      <input
                        type="checkbox"
                        id="active-advertise-alternative"
                        checked={activeAlternative}
                        onChange={() => {
                          setActiveAlternative(!activeAlternative);
                        }}
                      />
                      <span className="adl-slider round"></span>
                    </label>
                  </span>
                </div>

                {activeAlternative && (
                  <div className="form-group">
                    <label>
                      امتیاز نمایش یک تبلیغ بنری جایگزین در یک شبانه روز :{" "}
                    </label>
                    <span
                      className="letter-spacing-finance-number"
                      style={{ fontSize: "22px" }}
                    >
                      {helpersNumbers.toPersianNum(
                        helpersNumbers.toFormatFinanceNumber(scoreAlternative)
                      )}
                    </span>
                  </div>
                )}

                <div className="form-group">
                  <div className="pb-3">
                    <label>اندازه بنرهای تبلیغاتی ( ارتفاع - عرض) پیکسل</label>
                    <div className="container-fluid">
                      <div className="row">{generateButtonsSize()}</div>
                    </div>
                  </div>
                  <div className="d-flex flex-column flex-md-row">
                    <div className="pl-0 pl-md-2">
                      <label>ارتفاع</label>

                      <input
                        dir="ltr"
                        type="number"
                        id="height"
                        value={height || ""}
                        className="form-control"
                        required
                      />
                    </div>
                    <div>
                      <label>عرض</label>
                      <input
                        dir="ltr"
                        type="number"
                        id="width"
                        value={width || ""}
                        className="form-control"
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <span className="pl-2">
                    <label>فعال</label>
                  </span>
                  <span>
                    <label className="adl-switch">
                      <input
                        type="checkbox"
                        id="active"
                        checked={active}
                        onChange={() => {
                          setActive(!active);
                        }}
                      />
                      <span className="adl-slider round"></span>
                    </label>
                  </span>
                </div>

                <div className="form-group">
                  <ButtonDisable
                    buttonTagHtml={
                      <span className="btn btn-success opacity-50">
                        ویرایش کردن
                      </span>
                    }
                  ></ButtonDisable>
                </div>

                <div className="form-group">
                  <div className="border border-success">
                    <a
                      href={`${process.env.REACT_APP_DOMAIN_API}/${process.env.REACT_APP_URL_PAGE_FILES}/${page?.img_name}`}
                      target="_blank"
                    >
                      <img
                        className="img-fluid"
                        src={`${process.env.REACT_APP_DOMAIN_API}/${process.env.REACT_APP_URL_PAGE_FILES}/${page?.img_name}`}
                      />
                    </a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
